<template>
<a name="Potionssss">
  <div class="module-wrapper">
    <lazy-component @show.once="render(false)">
    <div  v-if="!loadError">
      <ModuleTitle title="基金档案"
      desc="概况、持仓、规模、分红"
      :rightArrow="true"
      :rightButtonEvent="clickMore" />
      <GeneralSituation ref="GeneralSituationView"/>
      <Manager ref="ManagerView"/>
      <TZLN ref="TZLNView" />
      <a name="HoldFund" />
      <div id="jjFundHoldFund"></div>
      <FundChartHold FCODE="000960" ref="chartHold" :showEmpty="showEmpty"  v-if="!dataEmpty"/>
        <div class="etitlev">
      <div class="eholdV" v-if="dataEmpty">基金持仓
        </div>
        <div class="eholdVs" v-if="dataEmpty" >暂无持仓信息</div>
      </div>
      <!--持仓列表-->
      <FundTablePositions v-if="holdListType === '0' && !dataEmpty" ref="FundTablePositions"/>
      <FundTablePositionsFof v-if="holdListType === '2' && !dataEmpty" ref="FundTablePositions"/>
      <FundTablePositionsHb v-if="holdListType === '1' && !dataEmpty" ref="FundTablePositions"/>
      <FundTablePositionsEtf v-if="holdListType === '3' && !dataEmpty" ref="FundTablePositions"/>
      <div v-if="!dataEmpty" class="moreHoldBottom" @click="clickMoreHold" >
        <span class="moreHoldBottomtitle">更多持仓信息</span>
      </div>
      <div class="holdline linetop"></div>
      <DividendDistribution v-if="holdListType !== '1'" />
      <div class="holdline linetop" v-if="gpkhTip.length > 0 && showEMAccount" ></div>
      <div class="gpkhtip-view"
      v-if="gpkhTip.length > 0 && showEMAccount " @click="gpkhClick">
        <span class="gpkhtip-text">{{gpkhTip}}</span>
      </div>
      <div class="spHoldView"></div>
    </div>
    <div v-else>
      <ModuleTitle title="基金档案"
      desc="概况、持仓、规模、分红"
      :rightArrow="true"
      :rightButtonEvent="clickMore" />
      <ModuleReload :state="reloadErrorState" :click="clickReloadError"/>
    </div>
    </lazy-component>
  </div>
  </a>
</template>

<script>
import NativeMsg from '@/base/NativeMsg';
import ModuleTitle from '@/components/ModuleTitle.vue';
import ModuleReload from '@/components/ModuleReload.vue';
import GeneralSituation from '@/components/Fund-GeneralSituation.vue';
import Manager from '@/components/Fund-Manager.vue';
import TZLN from '@/components/Fund-TZLN.vue';
import DividendDistribution from '@/components/Fund-DividendDistribution.vue';
import FundTablePositions from '@/components/FundTable-Positions.vue';
import FundTablePositionsFof from '@/components/FundTable-PositionsFof.vue';
import FundTablePositionsHb from '@/components/FundTable-PositionsHb.vue';
import FundTablePositionsEtf from '@/components/FundTable-PositionsEtf.vue';
import FundChartHold from '@/components/FundChart/hold.vue';
import FundTypeSearch from '@/utils/FundTypeSearch';
import StoreManger from '@/utils/FundHQJHManger';
import {
  detailPushPage,
} from '@/utils/nativeBridge';
import JS from '@/base/JSTool';

export default {
  name: 'FundPositions',
  components: {
    TZLN,
    GeneralSituation,
    ModuleTitle,
    FundTablePositions,
    FundTablePositionsFof,
    FundTablePositionsHb,
    FundTablePositionsEtf,
    FundChartHold,
    Manager,
    DividendDistribution,
    ModuleReload,
  },
  data() {
    return {
      nativeData: {},
      fundCode: '',
      fundType: '',
      holdListType: '0',
      reloadState: 0,
      dataEmpty: false,
      loading: true,
      loadError: false,
      reloadErrorState: 1,
      gpkhTip: '',
      gpkhLink: {},
      showEMAccount: false,
    };
  },
  computed: {
    isMonetaryfund() {
      return FundTypeSearch.isMonetaryfund(this.fundType);
    },
    isFOFFund() {
      return FundTypeSearch.isFOFFund(this.fundType);
    },
  },
  methods: {
    showEmpty() {
      this.dataEmpty = true;
    },
    configHoldType(item) {
      this.configureFund();
      const FEATURE = JS.fetchString(item, 'FEATURE');
      const FUNDTYPE = JS.fetchString(item, 'FUNDTYPE');
      const BFUNDTYPE = JS.fetchString(item, 'BFUNDTYPE');
      let isjzhb = false;
      if (FUNDTYPE === '205') {
        if (BFUNDTYPE === '004') {
          isjzhb = true;
        } else if (BFUNDTYPE === '005') {
          isjzhb = true;
        }
      }
      if (this.isMonetaryfund || isjzhb) {
        // 货币
        this.holdListType = '1';
      } else if (FEATURE.indexOf('031') !== -1) {
        // etf 重仓基金
        this.holdListType = '3';
      } else if (this.isFOFFund) {
        // fof
        this.holdListType = '2';
      } else {
        this.holdListType = '0';
      }
    },
    clickMoreHold() {
      const baseInfo = StoreManger.getFundJJXQ();
      const name = StoreManger.getFundJJXQNAME(baseInfo);
      const code = StoreManger.getFundJJXQCODE(baseInfo);

      detailPushPage({
        appId: 'b34ccfc4ed9a4af4a4880fee485cf417',
        url: '/pages/Index',
        params: {
          fundCode: code,
          fundName: name,
          index: '1',
        },
      });
    },
    async render(isCache) {
      const baseInfo = StoreManger.getFundJJXQ();
      if (!baseInfo) {
        this.loadError = true;
        return;
      }
      this.loadError = false;
      this.nativeData = this.$store.state.native.fund;
      this.fundCode = this.nativeData.fundCode;
      this.fundType = this.nativeData.fundType;
      this.configHoldType(baseInfo);
      const basedata = StoreManger.getFundJJCC();
      // const res = StoreManger.getFundJJGM();
      // let gmshow = true;
      // if (!res?.Datas?.length) {
      //   gmshow = false;
      // }
      if (!basedata) {
        this.dataEmpty = true;
        this.loading = false;
        return;
      }
      if (!basedata.InverstPosition) {
        this.dataEmpty = true;
      }
      this.loading = false;
      this.handleData(isCache);
      this.$refs.GeneralSituationView.render(isCache);
      this.$refs.ManagerView.render(isCache);
      this.$refs.TZLNView.render(isCache);
      this.configureGpkh();
      this.showEMOpenAccount();
    },
    async configureGpkh() {
      this.gpkhTip = '在线开户万2.5佣金，即刻参与基金重仓股行情！';
      this.gpkhLink = {
        LinkType: 2,
        AdId: 0,
        LinkTo: 'https://marketing.dfcfs.com/activitytemplate/?activityId=899&mk_source=mks_0000118',
        IsVerifyLogin: false,
        WapLink: '',
      };
    },
    showEMOpenAccount() {
      const basedata = StoreManger.getFundJJCC();
      if (basedata) {
        this.dataCc = basedata.InverstPosition;
        this.holddate = StoreManger.getFundJJCCExpansion();
      }
      if (!this.dataCc) {
        return;
      }
      const datas = this.dataCc.fundStocks;
      const datas2 = this.dataCc.fundboods;
      if (datas && datas.length > 0) {
        this.showEMAccount = true;
      } else if (datas2 && datas2.length > 0) {
        this.showEMAccount = true;
      } else {
        this.showEMAccount = false;
      }
    },
    gpkhClick() {
      const { LinkType, LinkTo } = this.gpkhLink;
      detailPushPage({
        type: LinkType,
        url: LinkTo,
      });
    },
    mainQueryError() {
      if (this.$refs.chartHold) {
        this.$refs.chartHold.mainQueryError();
      }
    },
    delhandleData(isCache) {
      setTimeout(() => this.renderchartHold(isCache), 300);
    },
    renderchartHold(isCache) {
      const refs = this.$refs;
      if (this.$refs.chartHold) {
        refs.chartHold.render(isCache);
      }
    },
    handleData(isCache) {
      const refs = this.$refs;
      const timer1 = setInterval(() => {
        if (this.$refs.FundTablePositions) {
          refs.FundTablePositions.render(isCache);
          clearInterval(timer1);
        }
      }, 300);
      const timer = setInterval(() => {
        if (this.$refs.chartHold) {
          this.delhandleData(isCache);
          clearInterval(timer);
        }
      }, 300);
    },
    getshowListModule(Modules, code, needSuitScene) {
      if (Modules) {
        const showModules = Modules.filter(
          (item) => (item.ModuleCode === code && item.CustomArray.length > 0),
        );
        if (showModules.length > 0) {
          const showModule = showModules[0];
          let { CustomArray } = showModule;
          CustomArray = CustomArray.filter(
            (item) => (item.SpecialSuitScene === needSuitScene),
          );
          return CustomArray;
        }
      }
      return [];
    },
    configureFund() {
      this.nativeData = this.$store.state.native.fund;
      this.fundCode = this.nativeData.fundCode;
      this.fundType = this.nativeData.fundType;
    },
    clickReloadError() {
      NativeMsg.post(JSON.stringify({ key: 'reflash', value: { v: 'start' } }));
    },
    clickReload() {
      this.reloadState = 0;
      this.loading = true;
      this.render(false);
    },
    clickMore() {
      const baseInfo = StoreManger.getFundJJXQ();
      const name = StoreManger.getFundJJXQNAME(baseInfo);
      const code = StoreManger.getFundJJXQCODE(baseInfo);

      detailPushPage({
        appId: 'b34ccfc4ed9a4af4a4880fee485cf417',
        url: '/pages/Index',
        params: {
          fundCode: code,
          fundName: name,
          index: '0',
        },
      });
      this.reportMonitor({
        eventName: 'pz.xx.gd.click',
      });
    },
  },
};
</script>

<style scoped lang="less">
.maidian{
   padding-top:88px;
   margin-top:-88px;
   pointer-events: none;
}
  .module-wrapper {
    margin-left: 24px;
    margin-right: 24px;
    margin-bottom: 24px;
    background: #fff;
    border-radius: 12px;
  }
  .tab-wrapper {
    display: flex;
    border-bottom: 2px solid #EEEEEE;
    margin-left: 24px;
    margin-right: 24px;

    > div {
      flex: 1;
    }
  }

  .tab-label {
    font-family: PingFangSC-Regular;
    font-size: 32px;
    text-align: center;
    color: #666666;
    height: 88px;
    line-height: 88px;
    display: inline-block;
  }

  .tab-selected {
    border-bottom: 4px solid #FF4400;
    color: #FF4400;
  }

  .etitlev{
    padding-top: 8px;
    padding-left: 30px;
    padding-right: 30px;
  height: 40px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.eholdVs{
  display: flex;
  align-items: center;
  font-family: PingFangSC-Regular;
  font-size: 28px;
  color: #999999;
  letter-spacing: 0;
  line-height: 28px;
  margin-bottom: 30px;
}
.eholdV{
  display: flex;
  align-items: center;
  font-family: PingFangSC-Regular;
  font-size: 28px;
  color: #666666;
  letter-spacing: 0;
  line-height: 28px;
  margin-bottom: 30px;
}
.gpkhtip-view{
  padding-bottom: 12px;
  padding-top: 20px;
  margin-left: 24px;
  margin-right: 24px;
}
.holdline {
  margin-left: 30px;
  margin-right: 30px;
}
.spHoldView{
  height: 10px;
}
.gpkhtip-text{
  font-family: PingFangSC-Regular;
  font-size: 28px;
  line-height: 38px;
  margin-bottom: 10px;
  margin-top: 10px;
  display: flex;
  font-family: PingFangSC-Regular;
  font-size: 28px;
  color: #83A6CF;
}

.moreHoldBottom {
  margin-left: 30px;
  margin-right: 30px;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  display: flex;
  padding-top: 26px;
  padding-bottom: 30px;
}
.moreHoldBottomtitle {
  font-family: PingFangSC-Regular;
  font-size: 30px;
  color: #008AFF;
  text-align: center;
  line-height: 30px;
}
</style>
